import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { hooks } from 'roadie-ui'
import { fetchDriverCerts } from 'actions/profile'
import { useDispatch } from 'hooks/useDispatch'
import type { ProfileDeliveryCertification } from 'data/driverCertifications'

type DriverCertResult = {
  loading: boolean
  hasDriverCert: boolean
  isDriverCertRevoked: boolean
}

const useDriverCert = (cert: string): DriverCertResult => {
  const loading = hooks.useToggle(true)
  const dispatch = useDispatch()
  const trainingCertifications = useSelector<any, ProfileDeliveryCertification[]>(
    (state) => state.trainingCertifications?.delivery_certifications_drivers ?? []
  )

  useEffect(() => {
    if (loading.value) {
      fetchDriverCerts()(dispatch).then(loading.off)
    }
  }, [dispatch, loading])

  const driverCert = trainingCertifications.find((trainingCertification) => trainingCertification.name === cert)

  if (loading.value) {
    return {
      loading: true,
      hasDriverCert: false,
      isDriverCertRevoked: false,
    }
  } else {
    return {
      loading: false,
      hasDriverCert: !!driverCert && !driverCert.is_revoked,
      isDriverCertRevoked: !!driverCert?.is_revoked,
    }
  }
}

export default useDriverCert
